import { useState } from 'react';
import { useReduxState } from 'hooks';
import { CalendarEventsViewAllCalendarEvents } from 'components/calendar';

import type { HomeModuleProps } from './Home';

const HomeCalendarEventsAvailable = ({
  defaultTitle,
  limit,
  module,
  spacing
}: HomeModuleProps) => {
  const { language } = useReduxState();

  const [noData, setNoData] = useState(false);

  if (!module) return null;

  const description =
    module.descriptionTranslations?.[language] || module.description;

  const title =
    module.titleTranslations?.[language] || module.title || defaultTitle;

  return (
    <div {...(!noData ? { style: { marginTop: spacing } } : {})}>
      <CalendarEventsViewAllCalendarEvents
        description={description}
        hideIfNoData={true}
        isHomeView={true}
        limitPerPage={module.limit || limit}
        onNoData={(hasNoData) => setNoData(!hasNoData)}
        showAdminTiles={false}
        showAllLinkHref="/calendar?page=1&view=list&status=available&category=all&type=current"
        title={title}
        titleShowCount={false}
        queryParams={`&timeFrame=current&view=list&status=available`}
      />
    </div>
  );
};

export default HomeCalendarEventsAvailable;
